import { defineMessages } from 'react-intl';
import regexesValidation from 'utils/validator/regexesValidation';

const messages = defineMessages({
  fieldCanContainOnlyNumber: 'To pole powinno zawierać tylko liczby',
});

export default (value, positiveValueOnly = false) => {
  const result = {};

  let regexp = regexesValidation.isNumber;

  if (positiveValueOnly) {
    regexp = regexesValidation.isNumberPositiveOnly;
  }

  result.isValid = !value || !!value.toString().match(regexp);
  result.message = messages.fieldCanContainOnlyNumber;

  return result;
};
